// Store order for navigation
const STORE_ORDER = ['frederiksberg', 'aarhus', 'hammerholmen', 'amager'];

// Helper function to get image URL from Shopify image object or string
function getImageUrl(imageObject) {
  if (!imageObject) return '';
  if (typeof imageObject === 'string') return imageObject;
  // Shopify image objects might have different structures
  if (imageObject.src) return imageObject.src;
  if (imageObject.url) return imageObject.url;
  return '';
}

// Store Information Data - Falls back to hardcoded if not configured in theme
// Force reload if config version changed
const configScript = document.getElementById('store-data-config');
if (configScript && window.STORE_DATA_CONFIG && window.STORE_DATA_CONFIG_VERSION) {
  const currentVersion = configScript.getAttribute('data-version');
  if (currentVersion && currentVersion !== window.STORE_DATA_CONFIG_VERSION) {
    // Config was updated, clear any cached data and reload page to get fresh data
    console.log('Store data config updated, clearing cache');
    delete window.STORE_DATA_CONFIG;
    // Force reload to get fresh data from server
    if (currentVersion) {
      window.location.reload();
    }
  }
}
// Always get the latest version from the script tag
window.STORE_DATA_CONFIG_VERSION = configScript?.getAttribute('data-version') || '';

const STORE_DATA = window.STORE_DATA_CONFIG || {
  frederiksberg: {
    name: 'Spinchy',
    nameEn: 'Spinchy',
    excerpt: 'Vores flagskibsbutik i hjertet af Frederiksberg',
    excerptEn: 'Our flagship store in the heart of Frederiksberg',
    address: 'Gl. Kongevej 84, 1850 Frederiksberg',
    image: 'https://spinchy.com/cdn/shop/files/Frederiksberg_1.jpg?v=1714510127', // Tilføj billede URL her
    openingHours: {
      monday: '10.00-18.00',
      tuesday: '10.00-18.00',
      wednesday: '10.00-18.00',
      thursday: '10.00-18.00',
      friday: '10.00-18.00',
      saturday: '10.00-16.00',
      sunday: 'Lukket'
    }
  },
  aarhus: {
    name: 'Spinchy',
    nameEn: 'Spinchy',
    excerpt: 'Vores butik i Aarhus centrum',
    excerptEn: 'Our store in Aarhus city center',
    address: 'Klostergade 20, 8000 Aarhus C',
    image: 'https://spinchy.com/cdn/shop/files/Aarhus_1.jpg?v=1714510162', // Tilføj billede URL her
    openingHours: {
      monday: '10.00-18.00',
      tuesday: '10.00-18.00',
      wednesday: '10.00-18.00',
      thursday: '10.00-18.00',
      friday: '10.00-18.00',
      saturday: '10.00-16.00',
      sunday: 'Lukket'
    }
  },
  hammerholmen: {
    name: 'Yellow Bird Coffee',
    nameEn: 'Yellow Bird Coffee',
    excerpt: 'Vores lager på Hammerholmen',
    excerptEn: 'Our warehouse at Hammerholmen',
    address: 'Hammerholmen 9A, 2650 Hvidovre',
    image: 'https://spinchy.com/cdn/shop/files/ChatGPT_Image_Nov_18_2025_12_10_58_PM.png?v=1763464431', // Tilføj billede URL her
    openingHours: {
      monday: '09:00-16:00',
      tuesday: '09:00-16:00',
      wednesday: '09:00-16:00',
      thursday: '09:00-16:00',
      friday: '09:00-16:00',
      saturday: 'Lukket',
      sunday: 'Lukket'
    }
  },
  amager: {
    name: 'Yellow Bird Coffee',
    nameEn: 'Yellow Bird Coffee',
    excerpt: 'Vores café på Amager',
    excerptEn: 'Our cafe at Amager',
    address: 'Amager Strandvej 108, 2300 København',
    image: 'https://cdn.shopify.com/s/files/1/0895/0920/0220/files/IMG_1458.jpg?v=1769175580', // Tilføj billede URL her
    openingHours: {
      monday: '7:30-17:00',
      tuesday: '7:30-17:00',
      wednesday: '7:30-17:00',
      thursday: '7:30-17:00',
      friday: '7:30-17:00',
      saturday: '9:00-17:30',
      sunday: '9:00-17:30'
    }
  }
};

// Store Information Popup Component
class StoreInformationPopup {
  constructor() {
    this.dialog = null;
    this.currentStoreId = null;
    this.touchStartX = null;
    this.touchStartY = null;
    this.touchStartTime = null;
    this.isScrolling = false;
    this.init();
  }

  init() {
    this.createPopupHTML();
    this.attachEventListeners();
  }

  createPopupHTML() {
    // Remove old dialog if it exists
    const oldDialog = document.getElementById('store-information-popup');
    if (oldDialog) {
      oldDialog.remove();
    }
    
    const popupHTML = `
      <dialog id="store-information-popup" class="store-information-popup" scroll-lock>
        <div class="store-information-popup__inner">
          <button class="store-information-popup__close" aria-label="Luk">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="store-information-popup__content">
            <div class="store-information-popup__image" id="store-image">
              <img id="store-image-img" src="" alt="" style="display: none;">
            </div>
            <div class="store-information-popup__info">
              <h2 class="store-information-popup__title" id="store-title"></h2>
              <p class="store-information-popup__excerpt" id="store-excerpt"></p>
              <div class="store-information-popup__address">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 10.8333C11.3807 10.8333 12.5 9.71404 12.5 8.33333C12.5 6.95262 11.3807 5.83333 10 5.83333C8.61929 5.83333 7.5 6.95262 7.5 8.33333C7.5 9.71404 8.61929 10.8333 10 10.8333Z" stroke="currentColor" stroke-width="1.5"/>
                  <path d="M10 18.3333C13.3333 15 16.6667 11.6667 16.6667 8.33333C16.6667 4.015 13.315 1.66667 10 1.66667C6.685 1.66667 3.33333 4.015 3.33333 8.33333C3.33333 11.6667 6.66667 15 10 18.3333Z" stroke="currentColor" stroke-width="1.5"/>
                </svg>
                <a id="store-address" href="#" target="_blank" rel="noopener noreferrer" class="store-information-popup__address-link"></a>
              </div>
              <div class="store-information-popup__opening-hours">
                <div class="store-information-popup__notice-banner" id="store-notice-banner" style="display: none;">
                  <div class="store-information-popup__notice-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/>
                      <path d="M10 6V10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      <circle cx="10" cy="13" r="1" fill="currentColor"/>
                    </svg>
                  </div>
                  <div class="store-information-popup__notice-text" id="store-notice-text"></div>
                </div>
                <h3 class="store-information-popup__section-title">${Shopify.locale === 'en' ? 'Opening Hours' : 'Åbningstider'}</h3>
                <div class="store-information-popup__hours-list" id="store-hours"></div>
                <p class="store-information-popup__hours-disclaimer">${Shopify.locale === 'en' ? 'Note: Opening hours may vary on holidays and special occasions.' : 'Bemærk: Der tages forbehold for helligdage og særlige begivenheder.'}</p>
              </div>
              <div class="store-information-popup__navigation">
                <button class="store-information-popup__nav-button store-information-popup__nav-button--prev" id="store-nav-prev" aria-label="${Shopify.locale === 'en' ? 'Previous store' : 'Forrige butik'}">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>${Shopify.locale === 'en' ? 'Previous' : 'Forrige'}</span>
                </button>
                <button class="store-information-popup__nav-button store-information-popup__nav-button--next" id="store-nav-next" aria-label="${Shopify.locale === 'en' ? 'Next store' : 'Næste butik'}">
                  <span>${Shopify.locale === 'en' ? 'Next' : 'Næste'}</span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </dialog>
    `;
    
    document.body.insertAdjacentHTML('beforeend', popupHTML);
    this.dialog = document.getElementById('store-information-popup');
  }

  setStoreImage(storeId) {
    const store = STORE_DATA[storeId];
    if (!store) return;

    const imageContainer = document.getElementById('store-image');
    const imageImg = document.getElementById('store-image-img');
    
    const imageUrl = getImageUrl(store.image);
    
    if (imageUrl && imageUrl.trim() !== '') {
      imageImg.src = imageUrl;
      imageImg.alt = store.name;
      imageImg.style.display = 'block';
      imageContainer.style.display = 'block';
    } else {
      imageContainer.style.display = 'none';
    }
  }

  // Danish public holidays (fixed dates)
  getDanishHolidays(year) {
    const holidays = [
      // Fixed holidays
      { month: 0, day: 1 },   // New Year's Day
      { month: 4, day: 1 },   // Labour Day
      { month: 4, day: 5 },   // Constitution Day
      { month: 5, day: 5 },   // Constitution Day (alternative)
      { month: 11, day: 24 }, // Christmas Eve
      { month: 11, day: 25 }, // Christmas Day
      { month: 11, day: 26 }, // Boxing Day
      { month: 11, day: 31 }, // New Year's Eve
    ];
    
    // Calculate Easter and related holidays (variable dates)
    const easter = this.calculateEaster(year);
    const easterMonday = new Date(easter);
    easterMonday.setDate(easter.getDate() + 1);
    
    const ascensionDay = new Date(easter);
    ascensionDay.setDate(easter.getDate() + 39);
    
    const whitMonday = new Date(easter);
    whitMonday.setDate(easter.getDate() + 50);
    
    const goodFriday = new Date(easter);
    goodFriday.setDate(easter.getDate() - 2);
    
    return [
      ...holidays.map(h => new Date(year, h.month, h.day)),
      easter,
      easterMonday,
      ascensionDay,
      whitMonday,
      goodFriday
    ];
  }

  // Calculate Easter date (simplified algorithm)
  calculateEaster(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month, day);
  }

  // Check if today is a Danish holiday
  isHoliday() {
    const now = this.getCurrentDanishTime();
    const year = now.getFullYear();
    const holidays = this.getDanishHolidays(year);
    
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    
    return holidays.some(holiday => {
      const holidayDate = new Date(holiday.getFullYear(), holiday.getMonth(), holiday.getDate());
      return today.getTime() === holidayDate.getTime();
    });
  }

  // Get current time in Danish timezone
  getCurrentDanishTime() {
    const now = new Date();
    // Convert to Danish time (CET/CEST)
    const danishTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' }));
    return danishTime;
  }

  // Parse time string (e.g., "10.00-18.00" or "09:00-16:00")
  parseTimeRange(timeString) {
    if (!timeString || timeString === 'Lukket' || timeString.toLowerCase().includes('lukket')) {
      return null;
    }
    
    // Handle both . and : as separators
    const normalized = timeString.replace(/\./g, ':');
    const parts = normalized.split('-');
    if (parts.length !== 2) return null;
    
    const [start, end] = parts.map(time => {
      const [hours, minutes = '00'] = time.trim().split(':');
      return { hours: parseInt(hours, 10), minutes: parseInt(minutes, 10) };
    });
    
    return { start, end };
  }

  // Check if store is currently open
  isStoreOpenNow(store) {
    // Don't show "open now" on holidays
    if (this.isHoliday()) {
      return false;
    }
    
    const now = this.getCurrentDanishTime();
    const currentDay = now.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();
    const currentTime = currentHours * 60 + currentMinutes; // minutes since midnight
    
    // Map JavaScript day (0=Sunday) to our day keys
    const dayMap = {
      0: 'sunday',
      1: 'monday',
      2: 'tuesday',
      3: 'wednesday',
      4: 'thursday',
      5: 'friday',
      6: 'saturday'
    };
    
    const dayKey = dayMap[currentDay];
    const hours = store.openingHours[dayKey];
    const timeRange = this.parseTimeRange(hours);
    
    if (!timeRange) return false;
    
    const startTime = timeRange.start.hours * 60 + timeRange.start.minutes;
    const endTime = timeRange.end.hours * 60 + timeRange.end.minutes;
    
    return currentTime >= startTime && currentTime < endTime;
  }

  populateStoreInfo(storeId) {
    // Always use the latest STORE_DATA_CONFIG if available
    const currentStoreData = window.STORE_DATA_CONFIG || STORE_DATA;
    const store = currentStoreData[storeId];
    if (!store) {
      console.warn(`Store data not found for: ${storeId}`);
      return;
    }

    // Get locale - check both Shopify.locale and window.Shopify.locale
    const shopifyLocale = (window.Shopify && window.Shopify.locale) || (typeof Shopify !== 'undefined' && Shopify.locale) || '';
    const locale = shopifyLocale === 'en' ? 'En' : '';
    
    // Get title element and update it
    const titleElement = document.getElementById('store-title');
    if (titleElement) {
      // Prioritize localized name, fallback to default name
      const title = store[`name${locale}`] || store.name || '';
      if (title && title.trim() !== '') {
        titleElement.textContent = title.trim();
        console.log(`Store title set to: ${title.trim()} (locale: ${locale || 'default'})`);
      } else {
        // Fallback if title is empty
        titleElement.textContent = store.name || 'Butik';
        console.warn(`Store title was empty, using fallback: ${store.name || 'Butik'}`);
      }
    } else {
      console.error('Store title element not found');
    }
    document.getElementById('store-excerpt').textContent = store[`excerpt${locale}`] || store.excerpt;
    
    // Set address as clickable link to Google Maps
    const addressLink = document.getElementById('store-address');
    addressLink.textContent = store.address;
    addressLink.href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(store.address)}`;

    // Check if store is open now
    const isOpenNow = this.isStoreOpenNow(store);
    const now = this.getCurrentDanishTime();
    const currentDay = now.getDay();
    const dayMap = {
      0: 'sunday',
      1: 'monday',
      2: 'tuesday',
      3: 'wednesday',
      4: 'thursday',
      5: 'friday',
      6: 'saturday'
    };
    const currentDayKey = dayMap[currentDay];

    // Show/hide notice banner (OBS - Vær opmærksom)
    const noticeBanner = document.getElementById('store-notice-banner');
    const noticeText = document.getElementById('store-notice-text');
    if (noticeBanner && noticeText) {
      // Always use the latest STORE_DATA_CONFIG if available
      const currentStoreData = window.STORE_DATA_CONFIG || STORE_DATA;
      const currentStore = currentStoreData[storeId] || store;
      
      const shopifyLocale = (window.Shopify && window.Shopify.locale) || (typeof Shopify !== 'undefined' && Shopify.locale) || '';
      const locale = shopifyLocale === 'en' ? 'En' : '';
      
      // Get notice from current store data
      const notice = currentStore[`notice${locale}`] || currentStore.notice || '';
      
      // Only show banner if notice is not blank
      if (notice && notice.trim() !== '') {
        noticeText.textContent = notice.trim();
        noticeBanner.style.display = 'flex';
      } else {
        noticeBanner.style.display = 'none';
      }
    }

    // Populate opening hours
    const hoursContainer = document.getElementById('store-hours');
    const days = [
      { key: 'monday', label: Shopify.locale === 'en' ? 'Monday' : 'Mandag' },
      { key: 'tuesday', label: Shopify.locale === 'en' ? 'Tuesday' : 'Tirsdag' },
      { key: 'wednesday', label: Shopify.locale === 'en' ? 'Wednesday' : 'Onsdag' },
      { key: 'thursday', label: Shopify.locale === 'en' ? 'Thursday' : 'Torsdag' },
      { key: 'friday', label: Shopify.locale === 'en' ? 'Friday' : 'Fredag' },
      { key: 'saturday', label: Shopify.locale === 'en' ? 'Saturday' : 'Lørdag' },
      { key: 'sunday', label: Shopify.locale === 'en' ? 'Sunday' : 'Søndag' }
    ];

    hoursContainer.innerHTML = days.map(day => {
      const isToday = day.key === currentDayKey;
      const isOpen = isToday && isOpenNow;
      const isClosed = store.openingHours[day.key] === 'Lukket' || store.openingHours[day.key].toLowerCase().includes('lukket');
      
      return `
        <div class="store-information-popup__hours-item ${isToday ? 'store-information-popup__hours-item--today' : ''} ${isOpen ? 'store-information-popup__hours-item--open' : ''}">
          <span class="store-information-popup__hours-day">${day.label}${isToday ? ' <span class="store-information-popup__hours-today-badge">I dag</span>' : ''}</span>
          <span class="store-information-popup__hours-time">
            ${store.openingHours[day.key]}
            ${isOpen ? '<span class="store-information-popup__hours-open-indicator" aria-label="Åben nu"></span>' : ''}
          </span>
        </div>
      `;
    }).join('');

    // Add pulsing indicator to opening hours section if open
    const openingHoursSection = document.querySelector('.store-information-popup__opening-hours');
    if (isOpenNow) {
      openingHoursSection.classList.add('store-information-popup__opening-hours--open-now');
    } else {
      openingHoursSection.classList.remove('store-information-popup__opening-hours--open-now');
    }
  }

  getNextStoreId(currentStoreId) {
    const currentIndex = STORE_ORDER.indexOf(currentStoreId);
    if (currentIndex === -1) {
      return STORE_ORDER[0]; // If not found, return first store
    }
    // Circular: if at last store, go to first
    const nextIndex = (currentIndex + 1) % STORE_ORDER.length;
    return STORE_ORDER[nextIndex];
  }

  getPreviousStoreId(currentStoreId) {
    const currentIndex = STORE_ORDER.indexOf(currentStoreId);
    if (currentIndex === -1) {
      return STORE_ORDER[STORE_ORDER.length - 1]; // If not found, return last store
    }
    // Circular: if at first store, go to last
    const prevIndex = (currentIndex - 1 + STORE_ORDER.length) % STORE_ORDER.length;
    return STORE_ORDER[prevIndex];
  }

  updateNavigationButtons() {
    const prevButton = document.getElementById('store-nav-prev');
    const nextButton = document.getElementById('store-nav-next');
    
    if (!prevButton || !nextButton || !this.currentStoreId) return;
    
    const prevStoreId = this.getPreviousStoreId(this.currentStoreId);
    const nextStoreId = this.getNextStoreId(this.currentStoreId);
    
    // Always enable buttons since navigation is infinite
    prevButton.disabled = false;
    prevButton.classList.remove('store-information-popup__nav-button--disabled');
    prevButton.onclick = () => this.navigateToStore(prevStoreId, 'prev');
    
    nextButton.disabled = false;
    nextButton.classList.remove('store-information-popup__nav-button--disabled');
    nextButton.onclick = () => this.navigateToStore(nextStoreId, 'next');
  }

  navigateToStore(storeId, direction = null) {
    if (!STORE_DATA[storeId]) return;
    
    // Add transition class for animation
    const content = document.querySelector('.store-information-popup__content');
    if (content) {
      content.classList.add('store-information-popup__content--transitioning');
      
      // Determine animation direction
      if (direction === 'next') {
        content.classList.add('store-information-popup__content--slide-left');
      } else if (direction === 'prev') {
        content.classList.add('store-information-popup__content--slide-right');
      }
    }
    
    // Update content after a short delay for smooth transition
    setTimeout(() => {
      this.currentStoreId = storeId;
      this.populateStoreInfo(storeId);
      this.setStoreImage(storeId);
      this.updateNavigationButtons();
      
      // Add slide in animation
      if (content) {
        if (direction === 'next') {
          content.classList.add('store-information-popup__content--slide-in-left');
        } else if (direction === 'prev') {
          content.classList.add('store-information-popup__content--slide-in-right');
        }
      }
      
      // Remove transition classes after animation
      setTimeout(() => {
        if (content) {
          content.classList.remove('store-information-popup__content--transitioning');
          content.classList.remove('store-information-popup__content--slide-left');
          content.classList.remove('store-information-popup__content--slide-right');
          content.classList.remove('store-information-popup__content--slide-in-left');
          content.classList.remove('store-information-popup__content--slide-in-right');
        }
      }, 300);
    }, 50);
  }

  open(storeId) {
    if (!STORE_DATA[storeId]) return;
    
    this.currentStoreId = storeId;
    this.populateStoreInfo(storeId);
    this.setStoreImage(storeId);
    this.updateNavigationButtons();
    
    if (this.dialog) {
      this.dialog.showModal();
    }
  }

  close() {
    if (this.dialog) {
      this.dialog.close();
    }
  }

  attachEventListeners() {
    // Close button
    const closeBtn = this.dialog?.querySelector('.store-information-popup__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.close());
    }

    // Close on backdrop click
    if (this.dialog) {
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) {
          this.close();
        }
      });
    }

    // Close on Escape key and handle arrow key navigation
    document.addEventListener('keydown', (e) => {
      // Only handle keyboard events when dialog is open
      if (!this.dialog?.open) return;
      
      if (e.key === 'Escape') {
        this.close();
        return;
      }
      
      // Arrow key navigation (only if dialog is open and no input is focused)
      const activeElement = document.activeElement;
      const isInputFocused = activeElement && (
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.isContentEditable
      );
      
      if (!isInputFocused) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          
          if (e.key === 'ArrowLeft') {
            const prevStoreId = this.getPreviousStoreId(this.currentStoreId);
            if (prevStoreId) {
              this.navigateToStore(prevStoreId, 'prev');
            }
          } else if (e.key === 'ArrowRight') {
            const nextStoreId = this.getNextStoreId(this.currentStoreId);
            if (nextStoreId) {
              this.navigateToStore(nextStoreId, 'next');
            }
          }
        }
      }
    });

    // Handle clicks on store pickup lines (delegated event listener)
    document.addEventListener('click', (e) => {
      // Check if clicked on a clickable store pickup line
      const storeLine = e.target.closest('.store-pickup-line--clickable');
      if (storeLine) {
        const storeId = storeLine.getAttribute('data-store-id');
        if (storeId && STORE_DATA[storeId]) {
          e.preventDefault();
          this.open(storeId);
        }
      }
      
      // Also handle clicks on old store-name-clickable elements (for backwards compatibility)
      const storeElement = e.target.closest('.store-name-clickable');
      if (storeElement) {
        const storeId = storeElement.getAttribute('data-store-id');
        if (storeId && STORE_DATA[storeId]) {
          e.preventDefault();
          this.open(storeId);
        }
      }
    });

    // Touch/swipe handling for mobile
    this.setupSwipeHandling();
  }

  setupSwipeHandling() {
    if (!this.dialog) return;

    let touchStartX = null;
    let touchStartY = null;
    let touchStartTime = null;
    let isScrolling = false;
    let scrollContainer = null;

    // Find scrollable container
    const infoContainer = document.querySelector('.store-information-popup__info');
    if (infoContainer) {
      scrollContainer = infoContainer;
    }

    this.dialog.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchStartTime = Date.now();
      isScrolling = false;
    }, { passive: true });

    this.dialog.addEventListener('touchmove', (e) => {
      if (!touchStartX || !touchStartY) return;

      const touchCurrentX = e.touches[0].clientX;
      const touchCurrentY = e.touches[0].clientY;
      const deltaX = touchCurrentX - touchStartX;
      const deltaY = touchCurrentY - touchStartY;

      // Check if user is scrolling vertically
      if (Math.abs(deltaY) > Math.abs(deltaX)) {
        isScrolling = true;
        return;
      }

      // Check if scroll container is scrollable and at boundaries
      if (scrollContainer) {
        const isAtTop = scrollContainer.scrollTop === 0;
        const isAtBottom = scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 1;
        
        // If scrolling and not at boundaries, don't interfere
        if (Math.abs(deltaY) > 10 && !isAtTop && !isAtBottom) {
          isScrolling = true;
          return;
        }
      }
    }, { passive: true });

    this.dialog.addEventListener('touchend', (e) => {
      if (!touchStartX || !touchStartY || isScrolling) {
        touchStartX = null;
        touchStartY = null;
        return;
      }

      const touchEndX = e.changedTouches[0].clientX;
      const touchEndY = e.changedTouches[0].clientY;
      const deltaX = touchEndX - touchStartX;
      const deltaY = touchEndY - touchStartY;
      const deltaTime = Date.now() - touchStartTime;

      // Swipe detection criteria:
      // - Horizontal movement > 50px
      // - Horizontal movement > vertical movement (more horizontal than vertical)
      // - Swipe duration < 500ms (quick swipe)
      // - Minimum horizontal movement > 30px
      const minSwipeDistance = 50;
      const maxSwipeTime = 500;
      const minHorizontalMovement = 30;

      if (
        Math.abs(deltaX) > minHorizontalMovement &&
        Math.abs(deltaX) > Math.abs(deltaY) &&
        Math.abs(deltaX) > minSwipeDistance &&
        deltaTime < maxSwipeTime
      ) {
        e.preventDefault();

        if (deltaX > 0) {
          // Swipe right - go to previous store
          const prevStoreId = this.getPreviousStoreId(this.currentStoreId);
          if (prevStoreId) {
            this.navigateToStore(prevStoreId, 'prev');
          }
        } else {
          // Swipe left - go to next store
          const nextStoreId = this.getNextStoreId(this.currentStoreId);
          if (nextStoreId) {
            this.navigateToStore(nextStoreId, 'next');
          }
        }
      }

      touchStartX = null;
      touchStartY = null;
      touchStartTime = null;
    }, { passive: false });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.storeInformationPopup = new StoreInformationPopup();
  });
} else {
  window.storeInformationPopup = new StoreInformationPopup();
}
